export default __webpack_public_path__ + "static/media/cotedazur.d56eb164.jpg";